"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

//fa-close
var Close = function Close() {
  return _react["default"].createElement("g", null, _react["default"].createElement("path", {
    d: "M431,362.6c0,7.9-2.7,14.5-8.2,20l-40.1,40.1c-5.5,5.5-12.2,8.2-20,8.2c-7.9,0-14.5-2.7-20-8.2L256,336.1l-86.6,86.6 c-5.5,5.5-12.2,8.2-20,8.2c-7.9,0-14.5-2.7-20-8.2l-40.1-40.1c-5.5-5.5-8.2-12.2-8.2-20c0-7.9,2.7-14.5,8.2-20l86.6-86.6l-86.6-86.6 c-5.5-5.5-8.2-12.2-8.2-20c0-7.9,2.7-14.5,8.2-20l40.1-40.1c5.5-5.5,12.2-8.2,20-8.2s14.5,2.7,20,8.2l86.6,86.6l86.6-86.6 c5.5-5.5,12.2-8.2,20-8.2s14.5,2.7,20,8.2l40.1,40.1c5.5,5.5,8.2,12.2,8.2,20c0,7.9-2.7,14.5-8.2,20l-86.6,86.6l86.6,86.6 C428.3,348.1,431,354.7,431,362.6z"
  }));
};

Close.displayName = 'Close';
var _default = Close;
exports["default"] = _default;
Close.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Close"
};

if (typeof STORYBOOK_REACT_CLASSES !== "undefined") {
  STORYBOOK_REACT_CLASSES["src/Close.js"] = {
    name: "Close",
    docgenInfo: Close.__docgenInfo,
    path: "src/Close.js"
  };
}